export default "__VITE_ASSET__IMTH7nyO__"